import useTranslation from 'next-translate/useTranslation';
import { Fragment } from 'react';

type GenericInfo = {
  [key: Exclude<string, 'name'>]: string;
};
interface PreciseAdditonalInfoI {
  name: string;
  details: Array<{ title?: string; content: string }>;
}

type AdditonalInfoI = PreciseAdditonalInfoI | GenericInfo;

function hasName(obj: AdditonalInfoI): obj is PreciseAdditonalInfoI {
  return typeof obj.name === 'string';
}

export function AdditionalInfoItem({ item: info }: { item: AdditonalInfoI }) {
  const { t } = useTranslation('products');

  const additional_information: Array<PreciseAdditonalInfoI> = [];

  if (hasName(info) && info.name == 'machine_history') {
    const assignOrder = info.details.map((detail) => addOrderNumber(detail));
    const arrayOrdered = assignOrder.slice(0);
    arrayOrdered.sort(function (a, b) {
      return (a?.order_number ?? 0) - (b?.order_number ?? 0);
    });
    if (arrayOrdered) {
      info.details = arrayOrdered;
    }
    additional_information.push(info);
  } else if (hasName(info) && info.name != 'extra_information') {
    additional_information.push(info);
  } else if (!hasName(info)) {
    Object.entries(info).forEach(([key, value]) => {
      const extra_information = {
        name: key,
        details: [{ content: value }],
      };
      additional_information.push(extra_information);
    });
  }

  return (
    <div
      className='title-additional-information'
      data-testid={`additional-info-${info.name}`}
    >
      {additional_information.map((info) => (
        <Fragment key={info.name}>
          <p className='border-b-[1px] py-5 font-secondary font-normal uppercase text-brand-500'>
            {t(`${info.name}`)}
          </p>
          <ul className='pt-8'>
            {hasName(info) && info.name == 'machine_history'
              ? info.details.map((detail, indexDetail) =>
                  detail.title != 'additional_information' ? (
                    <li key={indexDetail} className='text-gray-600'>
                      <strong className='uppercase'>
                        {t(`${detail.title}`)}:{' '}
                      </strong>
                      {detail.content}
                    </li>
                  ) : (
                    <li key={indexDetail} className='text-gray-600'>
                      <strong className='uppercase'>
                        {t(`${detail.title}`)}:{' '}
                      </strong>
                      {detail.content}
                    </li>
                  )
                )
              : null}
            {hasName(info) && info.name == 'machine_benefits'
              ? info.details.map((detail: any, indexDetail: number) => (
                  <li
                    key={indexDetail}
                    className='mb-4 space-y-4 text-gray-600'
                    data-testid={`additional-info-${info.name}-${indexDetail}`}
                  >
                    <strong className='uppercase'>
                      {t(`${detail.title}`)}:{' '}
                    </strong>
                    <ul className='wrapListBenefits'>
                      {detail.content.map((item: string, index: number) => {
                        return <li key={index}>{`- ${item}`}</li>;
                      })}
                    </ul>
                  </li>
                ))
              : null}
            {hasName(info) && info.name == 'extra_information'
              ? info.details.map((detail: any, indexDetail: number) => (
                  <li key={indexDetail} className='text-gray-600'>
                    - {detail.content}
                  </li>
                ))
              : null}
          </ul>
        </Fragment>
      ))}
    </div>
  );
}

function addOrderNumber(detail: {
  title?: string;
  order_number?: number;
  content: string;
}) {
  if (detail.title && detail.title == 'material_type') {
    detail.order_number = 0;
    return detail;
  }
  if (detail.title && detail.title == 'material_thickness') {
    detail.order_number = 1;
    return detail;
  }
  if (detail.title && detail.title == 'end_product') {
    detail.order_number = 2;
    return detail;
  }
  if (detail.title && detail.title == 'additional_information') {
    detail.order_number = 3;
    return detail;
  }
  return detail;
}
